import { useKeycloak } from "@react-keycloak/web";
import { memo, useEffect } from "react";

const loadScript = (url) => {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = url;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(`Failed to load script ${url}`);
        document.body.appendChild(script);
    });
};

const SupplyonNavBar = () => {
    const { keycloak } = useKeycloak();

    useEffect(() => {
        const supplyOnSpinPrefix = "https://platform.application." + process.env.REACT_APP_EnvironmentString + ".supplyon.com/navbar";
        const loadScripts = async () => {
            try {
                await Promise.all([loadScript(`${supplyOnSpinPrefix}/js/navbarConfig.js`), loadScript(`${supplyOnSpinPrefix}/js/supplyon-navbar.js`)]);
                const navbar = document.querySelector("supplyon-navbar");

                if (navbar && keycloak?.token && typeof navbar.setKeycloakAccessToken === "function") {
                    navbar.setKeycloakAccessToken(keycloak.token);
                } else {
                    console.warn("Navbar element or method not available.");
                }
            } catch (error) {
                console.error("Error loading scripts:", error);
            }
        };

        loadScripts();
    }, [keycloak?.token]);

    return (
        <div style={{height: '56px'}}>
            <supplyon-navbar app-name="riskmanagement" skip-authentication="true"></supplyon-navbar>
        </div>
    );
};

export default memo(SupplyonNavBar);